exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-advocate-js": () => import("./../../../src/pages/advocate.js" /* webpackChunkName: "component---src-pages-advocate-js" */),
  "component---src-pages-favorite-js": () => import("./../../../src/pages/favorite.js" /* webpackChunkName: "component---src-pages-favorite-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-statement-js": () => import("./../../../src/pages/statement.js" /* webpackChunkName: "component---src-pages-statement-js" */)
}

